import { createTheme } from '@mui/material/styles'
import components from './components'
import { themeOptions } from './palette'
import { colorPalette } from './palette/colorPalette'
import { colorPaletteDark } from './palette/colorPaletteDark'

/** @param {'light' | 'dark'} resolvedMode */
export function createAppTheme(resolvedMode = 'light') {
  const palette = resolvedMode === 'dark' ? colorPaletteDark : colorPalette
  return createTheme({
    ...themeOptions,
    palette,
    components,
  })
}

const muiTheme = createAppTheme('light')

export default muiTheme
